import { useFrame } from "@react-three/fiber";
import React from "react";
import * as THREE from "three";

const Spinner = ({ scale = 1 }: { scale: number }) => {
  const spinner = React.useRef<THREE.Mesh | null>(null);
  const groupref = React.useRef<THREE.Group>(null);

  useFrame(({ clock }) => {
    if (spinner.current) {
      spinner.current.rotation.z -= clock.getDelta() * 100;
    }
  });

  return (
    <group ref={groupref} scale={scale}>
      <mesh renderOrder={4} ref={spinner}>
        <ringGeometry args={[1.25, 1.5, 16, 1, 0, Math.PI / 1.5]} />
        <meshBasicMaterial depthTest={false} transparent></meshBasicMaterial>
      </mesh>
      <mesh renderOrder={4}>
        <ringGeometry args={[1.25, 1.5, 64]} />
        <meshBasicMaterial transparent depthTest={false} opacity={0.33} />
      </mesh>
    </group>
  );
};

export default Spinner;
